/* Edits the state whenever siteId is changed */

export default function openedFolder(state = [], action) {
	switch (action.type) {
	case 'FOLDER_OPEN' :
		return action.folder;

	default:
		return state;
	}
}
